module.exports = __webpack_public_path__ + "static/locator_pin_black-f4e67c2c87edc13a78ed788ef21e93cc.png";